// useHelmet.js
import { useEffect } from "react";

const useHelmet = (title) => {
  useEffect(() => {
    const defaultTitle = "Default Title"; // Set your default title here

    const updatedTitle = title || defaultTitle;

    const currentTitle = document.title;

    if (currentTitle !== updatedTitle) {
      document.title = updatedTitle;
    }

    return () => {
      if (currentTitle !== updatedTitle) {
        document.title = currentTitle;
      }
    };
  }, [title]);
};

export default useHelmet;
